import {useMemo} from 'react';
import {useKeycloak} from '@react-keycloak/web';
import {jwtDecode} from 'jwt-decode';
import _ from 'lodash';

export interface OwnClient {
    id: string;
    // true = the client belongs to the service organisation (internal). Its
    // users are service staff, so customer-facing "who serves me" panels don't
    // apply to them — they look at their customers' contacts instead.
    isServiceProvider: boolean;
}

/**
 * The current user's own client from the Keycloak JWT (`otto_identity.client`):
 * id plus the internal flag. Null when the token is missing/unreadable or the
 * identity carries no client (global admins have none).
 */
const useOwnClient = (): OwnClient | null => {
    const {keycloak} = useKeycloak();

    return useMemo<OwnClient | null>(() => {
        if (!keycloak?.token) return null;
        try {
            const decoded = jwtDecode<Record<string, unknown>>(keycloak.token);
            const clientId = _.get(decoded, 'otto_identity.client.id', null);
            if (clientId === null || clientId === undefined) return null;
            return {
                id: String(clientId),
                isServiceProvider: _.get(decoded, 'otto_identity.client.isServiceProvider', false) === true,
            };
        } catch {
            return null;
        }
    }, [keycloak?.token]);
};

export default useOwnClient;
